<template>
    <div class="mb-10">
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Bank Soal' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <div class="d-flex mb-1">
            <h3 class="header-text font-weight-bold">Bank Soal</h3>
        </div>

        <div class="mb-9">
            <v-row>
                <v-col cols="6">
                    <v-card flat>
                        <v-card-text class="pa-3">
                            <div class="d-flex align-center gap-15">
                                <div>
                                    <v-img
                                        :src="
                                            require('@/assets/img/icon_file.svg')
                                        "
                                        contain
                                        :width="50"
                                        :height="50"
                                    />
                                </div>
                                <div>
                                    <div class="grey--text font-weight-500">
                                        Total Soal
                                    </div>
                                    <div
                                        class="font-weight-700 primary--text mt-1"
                                        style="font-size: 24px"
                                    >
                                        {{
                                            formatNumber(
                                                total_data.total_item
                                            ) || 0
                                        }}
                                        <span class="font-size-14"> Soal </span>
                                    </div>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="6">
                    <v-card flat>
                        <v-card-text class="pa-3">
                            <div class="d-flex align-center gap-15">
                                <div>
                                    <v-img
                                        :src="
                                            require('@/assets/img/icon_file_validated.svg')
                                        "
                                        contain
                                        :width="50"
                                        :height="50"
                                    />
                                </div>
                                <div>
                                    <div class="grey--text font-weight-500">
                                        Total Soal Tervalidasi
                                    </div>
                                    <div
                                        class="font-weight-700 success--text mt-1"
                                        style="font-size: 24px"
                                    >
                                        {{
                                            formatNumber(
                                                total_data.total_item_valid
                                            ) || 0
                                        }}
                                        <span class="font-size-14"> Soal </span>
                                    </div>
                                </div>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>

        <v-card flat>
            <div
                class="d-flex align-center justify-space-between px-3 pt-3 font-weight-600 font-size-18 border-bottom pb-3 mt-5"
            >
                <div>Daftar Bank Soal</div>

                <v-spacer />
                <v-btn
                    depressed
                    dark
                    color="#42b873"
                    class="mr-1"
                    @click="onSearchData()"
                >
                    Refresh
                </v-btn>

                <v-btn
                    depressed
                    dark
                    color="blew"
                    @click="$router.push('/item-form?mapel=1')"
                >
                    <v-icon small class="mr-1">mdi-plus-circle</v-icon>
                    Soal
                </v-btn>
            </div>

            <div class="px-3 py-2 mb-5">
                <div class="mt-5">
                    <v-row>
                        <v-col :cols="3">
                            <v-select
                                v-model="mapel_id"
                                height="36px"
                                hide-details
                                placeholder="Pilih Mata Pelajaran"
                                dense
                                outlined
                                clearable
                                :items="mapelList"
                                item-text="nama"
                                item-value="id"
                            ></v-select>
                        </v-col>
                    </v-row>
                </div>
            </div>

            <v-card-text class="px-0 py-3 border-top-1">
                <div class="font-weight-600 px-3 font-size-16">Filter</div>

                <div class="mt-2">
                    <v-row class="no-gutters gap-10">
                        <v-col>
                            <!-- Search input with filters by headers key -->
                            <v-autocomplete
                                v-model="bab"
                                height="36px"
                                hide-details
                                placeholder="Bab"
                                dense
                                clearable
                                outlined
                                :items="list_bab"
                                item-text="bab_name"
                                item-value="bab_name"
                            ></v-autocomplete>
                        </v-col>

                        <v-col>
                            <v-autocomplete
                                v-model="subbab"
                                height="36px"
                                hide-details
                                placeholder="Sub Bab"
                                dense
                                clearable
                                outlined
                                :items="list_sub_bab"
                                item-text="sub_bab_name"
                                item-value="sub_bab_name"
                            ></v-autocomplete>
                        </v-col>

                        <!-- Sort by id feature -->
                        <v-col>
                            <v-autocomplete
                                id="datatable_sort"
                                v-model="subsubbab"
                                height="36px"
                                hide-details
                                placeholder="Sub Sub Bab"
                                clearable
                                dense
                                outlined
                                :items="list_sub_sub_bab"
                                item-text="sub_sub_bab_name"
                                item-value="sub_sub_bab_name"
                                @change="onSearchData()"
                            ></v-autocomplete>
                        </v-col>

                        <v-col>
                            <v-select
                                v-model="is_valid_filter"
                                height="36px"
                                hide-details
                                placeholder="Status Soal"
                                dense
                                clearable
                                outlined
                                :items="[
                                    { text: 'Valid', value: true },
                                    { text: 'Belum Valid', value: false },
                                ]"
                                item-text="text"
                                item-value="value"
                                @change="onSearchData()"
                            ></v-select>
                        </v-col>

                        <v-col>
                            <v-select
                                v-model="sort_type"
                                height="36px"
                                hide-details
                                placeholder="Urutkan Soal"
                                dense
                                clearable
                                outlined
                                :items="[
                                    { text: 'Baru ke Lama', value: 'desc' },
                                    { text: 'Lama ke Baru', value: 'asc' },
                                ]"
                                item-text="text"
                                item-value="value"
                                @change="onSearchData()"
                            ></v-select>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>

            <div class="px-3 pt-3 pb-4 border-top-1 border-bottom">
                <div class="d-flex gap-10">
                    <v-text-field
                        v-model="item_code"
                        placeholder="Ketik kode soal dan tekan enter"
                        dense
                        outlined
                        small
                        hide-details
                        append-icon="mdi-magnify"
                        @keyup.enter="onSearchData()"
                    ></v-text-field>

                    <v-btn
                        class="white--text"
                        color="blew"
                        depressed
                        height="2.8em"
                        @click="dialogAdvanceFilter = true"
                    >
                        Advance Filter
                    </v-btn>
                </div>

                <div v-if="advance_filter.length" class="mt-5 pt-3">
                    <v-chip
                        v-for="(data, i) in advance_filter"
                        :key="i"
                        close
                        color="#f3f5f7"
                        class="mr-2 custom-chip-close"
                        @click:close="removeFilter(i, data)"
                    >
                        {{ data.filter_name }} :
                        <span v-if="data.filter === 'is_pembahasan'">
                            {{ data.value === "true" ? "Ada" : "Tidak Ada" }}
                        </span>

                        <span v-else>
                            {{ data.value }}
                        </span>
                    </v-chip>
                </div>
            </div>

            <v-data-table
                v-model="datatable"
                single-select
                item-key="kode"
                class="mb-8"
                :headers="headers"
                :items="data"
                :server-items-length="totalItems"
                :items-per-page="itemsPerPage"
                :page.sync="page"
                :footer-props="{
                    'items-per-page-options': [10, 20, 50, 100, 500, 1000],
                }"
                @click:row="rowClick"
                @update:page="onSearchData"
                @update:items-per-page="onUpdatePerPages"
                no-data-text="Data itembank tidak tersedia"
            >
                <template v-slot:item.action="{ item }">
                    <v-menu offset-y transition="slide-y-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn text v-on="on">
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-card>
                            <v-list style="width: 180px">
                                <v-list-item-group>
                                    <v-list-item
                                        v-on:click="getDetailSoal(item)"
                                    >
                                        <v-list-item-title
                                            class="d-flex align-center gap-10"
                                        >
                                            <v-icon
                                                color="blew"
                                                class="menu-icon"
                                            >
                                                mdi-file-document-outline
                                            </v-icon>

                                            Detail
                                        </v-list-item-title>
                                    </v-list-item>

                                    <v-list-item v-on:click="getPreview(item)">
                                        <v-list-item-title
                                            class="d-flex align-center gap-10"
                                        >
                                            <v-icon
                                                color="blew"
                                                class="menu-icon"
                                            >
                                                mdi-cellphone
                                            </v-icon>

                                            Preview
                                        </v-list-item-title>
                                    </v-list-item>

                                    <v-list-item v-on:click="editSoal(item)">
                                        <v-list-item-title
                                            class="d-flex align-center gap-10"
                                        >
                                            <v-icon
                                                color="blew"
                                                class="menu-icon"
                                            >
                                                mdi-pencil-outline
                                            </v-icon>

                                            Edit
                                        </v-list-item-title>
                                    </v-list-item>

                                    <v-list-item
                                        v-on:click="editSoalNewTab(item)"
                                    >
                                        <v-list-item-title
                                            class="d-flex align-center gap-10"
                                        >
                                            <v-icon
                                                color="blew"
                                                class="menu-icon"
                                            >
                                                mdi-pencil-box-outline
                                            </v-icon>

                                            Edit New Tab
                                        </v-list-item-title>
                                    </v-list-item>

                                    <v-list-item
                                        v-on:click="confirmDelete(item)"
                                    >
                                        <v-list-item-title
                                            class="d-flex align-center gap-10"
                                        >
                                            <v-icon
                                                color="red"
                                                class="menu-icon"
                                            >
                                                mdi-delete-outline
                                            </v-icon>

                                            Hapus
                                        </v-list-item-title>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </v-card>
                    </v-menu>
                </template>

                <template v-slot:item.no="{ index }">
                    {{ (page - 1) * itemsPerPage + index + 1 }}
                </template>

                <template v-slot:item.sub_bab="{ item }">
                    {{ item.sub_bab ? item.sub_bab.nama : "-" }}
                </template>

                <template v-slot:item.sub_sub_bab="{ item }">
                    {{ item.sub_sub_bab ? item.sub_sub_bab.nama : "-" }}
                </template>

                <template v-slot:item.status="{ item }">
                    <div class="d-flex align-center">
                        <v-chip
                            v-if="item.is_new"
                            class="font-weight-600 pa-3 mb-2 mr-1"
                            x-small
                            color="#e2f5ea"
                            text-color="#27ae60"
                        >
                            New
                        </v-chip>

                        <v-chip
                            v-if="item.is_valid"
                            class="font-weight-600 pa-3 mb-2"
                            x-small
                            color="#e2f5ea"
                            text-color="#27ae60"
                        >
                            Valid
                        </v-chip>

                        <v-chip
                            v-if="!item.is_valid"
                            class="font-weight-600 pa-3 mb-2"
                            x-small
                            color="#f0f3f9"
                            text-color="#5e718d"
                        >
                            Belum Valid
                        </v-chip>
                    </div>
                </template>

                <template v-slot:item.grades="{ item }">
                    {{
                        item.grades
                            .map((e) => e.grade)
                            .sort((a, b) => a - b)
                            .join(", ")
                    }}
                </template>

                <template v-slot:no-results>
                    <div class="text-center">
                        <p class="my-2">Hasil pencarian tidak ditemukan.</p>
                    </div>
                </template>
            </v-data-table>

            <!-- <div class="d-flex justify-end pb-5">
                <v-pagination
                    v-model="page"
                    :total-visible="7"
                    :length="total_paging"
                ></v-pagination>
            </div> -->

            <div class="d-flex align-center gap-10 select-page">
                <div class="select-title">Select Page :</div>
                <div class="select-form">
                    <v-autocomplete
                        v-model="page"
                        hide-details
                        dense
                        outlined
                        maxlength="7"
                        :items="pageItems"
                        @change="onSearchPagingData"
                    />
                </div>
            </div>

            <v-dialog
                v-if="showDetails.open"
                v-model="showDetails.open"
                width="550px"
                min-height="537px"
                max-height="771px"
                @click:outside="showDetails.open = false"
                scrollable
            >
                <template v-slot:default="dialog">
                    <detail
                        :details="details"
                        @close="showDetails.open = false"
                        @preview="
                            getPreview(showDetails.function);
                            showDetails.open = false;
                        "
                    />
                </template>
            </v-dialog>

            <v-dialog
                v-model="showModal.open"
                width="300px"
                min-height="537px"
                max-height="771px"
                content-class="elevation-0"
                @click:outside="showModal.open = false"
                elevation="0"
                scrollable
            >
                <preview
                    v-if="showModal.open"
                    :preview="preview"
                    :loading="loading_preview"
                    @close="showModal.open = false"
                    @validate="validateItem(showModal.function)"
                />
            </v-dialog>

            <v-dialog v-model="dialogAdvanceFilter" persistent max-width="700">
                <dialog-advance-filter
                    @close="dialogAdvanceFilter = false"
                    @filter="onAdvanceFilter($event)"
                />
            </v-dialog>

            <v-dialog v-model="dialogConfirm.open" persistent max-width="500">
                <dialog-confirm
                    :title="dialogConfirm.title"
                    :subtitle="dialogConfirm.subtitle"
                    @close="dialogConfirm.open = false"
                    @confirm="
                        deleteSoal(dialogConfirm.function);
                        dialogConfirm.open = false;
                    "
                />
            </v-dialog>
        </v-card>

        <app-spinner v-if="loading"></app-spinner>
    </div>
</template>

<script>
import axios from "axios";
import ItemBankService from "@/modules/itembank/services/itembank.js";
import AppSpinner from "@/modules/global/components/plugins/Spinner";
import DialogConfirm from "@/modules/global/components/DialogConfirm";
import DialogAdvanceFilter from "./DialogAdvanceFilter.vue";
import Preview from "./Preview.vue";
import Detail from "./Detail.vue";

export default {
    name: "itembank",

    components: {
        AppSpinner,
        DialogConfirm,
        DialogAdvanceFilter,
        Preview,
        Detail,
    },

    data() {
        return {
            loading: false,
            dialogAdvanceFilter: false,
            dialogPreview: false,
            dialogDetail: false,
            datatable: null,
            mapel_id: null,
            bab: null,
            subbab: null,
            subsubbab: null,
            list_bab: [],
            list_sub_bab: [],
            list_sub_sub_bab: [],
            list_all_bab: [],
            list_all_sub_bab: [],
            list_all_sub_sub_bab: [],
            data: [],
            sort_type: null,
            advance_filter: [],
            headers: [
                {
                    text: "Aksi",
                    value: "action",
                    sortable: false,
                    width: 50,
                    align: "center",
                },
                { text: "No.", value: "no", sortable: false, width: 50 },
                {
                    text: "Status",
                    value: "status",
                    sortable: false,
                    width: 140,
                },
                { text: "Kode", value: "kode", sortable: false, width: 130 },
                {
                    text: "Mapel",
                    value: "nama_mapel",
                    sortable: false,
                    width: 130,
                },
                { text: "Bab", value: "bab.nama", sortable: false, width: 130 },
                {
                    text: "Sub Bab",
                    value: "sub_bab",
                    sortable: false,
                    width: 150,
                },
                {
                    text: "Sub Sub Bab",
                    value: "sub_sub_bab",
                    sortable: false,
                    width: 150,
                },
                {
                    text: "Tipe Pilihan",
                    value: "tipe_pilihan",
                    sortable: false,
                    width: 120,
                },
                {
                    text: "Jenjang",
                    value: "jenjang.nama",
                    sortable: false,
                    width: 120,
                },
                {
                    text: "Kelas",
                    value: "grades",
                    sortable: false,
                    width: 120,
                },
                {
                    text: "Jenis",
                    value: "jenis_soal.nama",
                    sortable: false,
                    width: 120,
                },
                {
                    text: "Label",
                    value: "label",
                    sortable: false,
                    width: 180,
                },
                {
                    text: "Tingkatkan Kesulitan",
                    value: "difficulty_level",
                    sortable: false,
                    width: 180,
                },
                {
                    text: "Soal Disembunyikan",
                    value: "is_restricted",
                    sortable: false,
                    width: 140,
                },
            ],
            data: [],
            filter: [],
            params: {
                size: 10,
                page: 1,
                sort_type: "desc",
            },
            detail: {},
            totalItems: 0,
            total_data: {
                total_item: null,
                total_item_valid: null,
            },
            showDetails: {
                open: false,
                function: null,
            },
            showModal: {
                open: false,
                function: null,
            },
            dialogConfirm: {
                open: false,
                title: null,
                subtitle: null,
                function: null,
            },
            itemsPerPage: 10,
            page: 1,
            total_paging: 0,
            dialogDetail: false,
            soal_baru: null,
            item_code: null,
            loading_preview: false,
            is_valid_filter: null,
            select_page: null,
            mapelList: JSON.parse(localStorage.getItem("mapels")),
        };
    },

    computed: {
        pageItems() {
            return Array.from({ length: this.total_paging }, (_, i) => i + 1);
        },
    },

    watch: {
        mapel_id(val) {
            this.onChangeMapel(val);
        },

        bab(val) {
            this.onChangeBab(val);
        },

        subbab(val) {
            this.onChangeSubbab(val);
        },
    },

    mounted() {
        this.fetchTotalItemData();
        this.fetchData();
        this.getListBab();
        this.getListSubBab();
        this.getListSubSubBab();
    },

    methods: {
        onUpdatePerPages(val) {
            this.itemsPerPage = val;
            this.onSearchData();
        },

        onSearchPagingData() {
            const page = this.page || 1;
            this.onSearchData(page);
        },

        onSearchData(newPage = 1) {
            this.params = {
                page: newPage,
                size: this.itemsPerPage,
                sort_type: this.sort_type || "desc",
                item_code: this.item_code,
                mapel_id: this.mapel_id,
                bab: this.bab,
                subbab: this.subbab,
                subsubbab: this.subsubbab,
                is_valid: this.is_valid_filter,
            };

            this.advance_filter.forEach((item) => {
                this.params[item.filter] = item.value;
            });

            this.page = newPage;

            this.fetchData();
        },

        fetchData() {
            const url = `${process.env.API_BASE_URL}itembank/items`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            const self = this;
            self.loading = true;

            axios
                .get(url, {
                    params: this.params,
                    ...options,
                })
                .then(function (response) {
                    self.data = response.data || [];
                    self.total_paging = response.data[0].pages;
                    self.totalItems = self.total_paging
                        ? self.total_paging * 10
                        : 0;
                })
                .finally(() => {
                    self.loading = false;
                });
        },

        fetchTotalItemData() {
            const url = `${process.env.API_BASE_URL}itembank/item/total`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            var self = this;

            axios.get(url, options).then(function (response) {
                self.total_data = response.data;
            });
        },

        getListBab() {
            const url = `${process.env.API_BASE_URL}itembank/bab/item`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            var self = this;

            axios.get(url, options).then(function (response) {
                self.list_bab = response.data;
                self.list_all_bab = response.data;
            });
        },

        getListSubBab() {
            const url = `${process.env.API_BASE_URL}itembank/subbab/item`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            var self = this;

            axios.get(url, options).then(function (response) {
                self.list_sub_bab = response.data;
                self.list_all_sub_bab = response.data;
            });
        },

        getListSubSubBab() {
            const url = `${process.env.API_BASE_URL}itembank/subsubbab/item`;
            const authToken = JSON.parse(localStorage.getItem("token")).value;
            const options = {
                headers: {
                    Authorization: "Bearer " + authToken,
                },
            };

            var self = this;

            axios.get(url, options).then(function (response) {
                self.list_sub_sub_bab = response.data;
                self.list_all_sub_sub_bab = response.data;
            });
        },

        async getDetailSoal(soal) {
            var self = this;

            await ItemBankService.getItemById(soal.id, function (results) {
                if (results.success) {
                    self.details = results.data;

                    // self.details.updated_at = this.$moment(
                    //     self.details.updated_at
                    // ).format("DD MMM YYYY");

                    self.grade_soal = [];

                    self.details.grades.forEach(function (grade) {
                        self.grade_soal.push(grade.grade);
                    });

                    self.showDetails.open = true;
                    self.showDetails.function = soal;
                } else {
                    self.$store.commit("showAlert", {
                        message: `Terjadi kesalahan`,
                        type: "error",
                    });
                }
            });
        },

        async getPreview(soal) {
            var self = this;
            self.loading = true;

            await ItemBankService.getItemPreviewById(
                soal.kode,
                function (results) {
                    if (results.success) {
                        self.preview = results.data;
                        self.showModal.open = true;
                        self.showModal.function = soal;
                    } else {
                        self.$store.commit("showAlert", {
                            message: `Terjadi kesalahan, soal ini tidak dapat di preview`,
                            type: "error",
                        });
                    }
                    self.loading = false;
                }
            );
        },

        validateItem(soal) {
            var self = this;
            var id = parseInt(soal.id);

            self.loading_preview = true;

            ItemBankService.validateSoal(id, function (result) {
                if (result.success) {
                    self.showModal.open = false;
                    self.loading_preview = false;
                    self.fetchData();
                } else {
                    self.$store.commit("showAlert", {
                        message: `Terjadi kesalahan!`,
                        type: "error",
                    });

                    self.loading_preview = false;
                }
            });
        },

        onAdvanceFilter(filter) {
            this.dialogAdvanceFilter = false;
            this.advance_filter = filter;

            this.item_code = null;
            this.bab = null;
            this.subbab = null;
            this.subsubbab = null;
            this.is_valid = null;

            this.onSearchData();
        },

        editSoal(value) {
            this.$router.push({
                path: "/item-form",
                query: {
                    id: value.id,
                    mapel: value.mapel_id,
                    edit: true,
                },
            });
        },

        editSoalNewTab(value) {
            let routeData = this.$router.resolve({
                path: "/item-form",
                query: {
                    id: value.id,
                    mapel: value.mapel_id,
                    edit: true,
                },
            });
            window.open(routeData.href, "_blank");
        },

        removeFilter(index, data) {
            this.advance_filter.splice(index, 1);

            this.onSearchData();
        },

        rowClick(item, row) {
            row.select(true);
        },

        formatNumber(value = 0) {
            return new Intl.NumberFormat("id-ID", {
                maximumFractionDigits: 0,
            }).format(value);
        },

        onChangeMapel(val) {
            this.bab = null;
            this.subbab = null;
            this.subsubbab = null;

            if (val) {
                this.advance_filter = [];
            }

            // filter untuk bab items
            this.list_bab = this.list_all_bab;
            const filteredBab = this.list_bab.filter((e) => e.mapel_id === val);
            this.list_bab = filteredBab.length
                ? filteredBab
                : this.list_all_bab;

            // filter untuk sub bab items
            this.list_sub_bab = this.list_all_sub_bab;
            const filteredSubBab = this.list_sub_bab.filter(
                (e) => e.mapel_id === val
            );
            this.list_sub_bab = filteredSubBab.length
                ? filteredSubBab
                : this.list_all_sub_bab;

            // filter untuk sub sub bab items
            this.list_sub_sub_bab = this.list_all_sub_sub_bab;
            const filteredSubSubBab = this.list_sub_sub_bab.filter(
                (e) => e.mapel_id === val
            );
            this.list_sub_sub_bab = filteredSubSubBab.length
                ? filteredSubSubBab
                : this.list_all_sub_sub_bab;

            this.onSearchData();
        },

        onChangeBab(val) {
            this.subbab = null;
            this.subsubbab = null;

            if (val) {
                this.advance_filter = [];
            }

            // filter untuk sub bab items
            this.list_sub_bab = this.list_all_sub_bab;
            const filteredSubBab = this.list_sub_bab.filter(
                (e) => e.bab_name === val
            );
            this.list_sub_bab = filteredSubBab.length
                ? filteredSubBab
                : this.list_all_sub_bab;

            // filter untuk sub sub bab items
            this.list_sub_sub_bab = this.list_all_sub_sub_bab;
            const filteredSubSubBab = this.list_sub_sub_bab.filter(
                (e) => e.bab_name === val
            );
            this.list_sub_sub_bab = filteredSubSubBab.length
                ? filteredSubSubBab
                : this.list_all_sub_sub_bab;

            this.onSearchData();
        },

        onChangeSubbab(val) {
            this.subsubbab = null;
            if (val) {
                this.advance_filter = [];
            }

            // filter untuk sub sub bab items
            this.list_sub_sub_bab = this.list_all_sub_sub_bab;
            const filteredSubSubBab = this.list_sub_sub_bab.filter(
                (e) => e.sub_bab_name === val
            );
            this.list_sub_sub_bab = filteredSubSubBab.length
                ? filteredSubSubBab
                : this.list_all_sub_sub_bab;

            this.onSearchData();
        },

        confirmDelete(val) {
            this.dialogConfirm.title = "Hapus Soal";
            this.dialogConfirm.subtitle =
                "Apakah Anda yakin akan menghapus soal ini?";

            this.dialogConfirm.function = val;
            this.dialogConfirm.open = true;
        },

        deleteSoal(data) {
            var context = this;

            ItemBankService.deleteItem(data.id, function (result) {
                if (result.success) {
                    var targetIndex = context.items.findIndex(function (item) {
                        return item.id == data.id;
                    });

                    context.items.splice(targetIndex, 1);
                }
            });
        },
    },
};
</script>

<style scoped>
.v-data-table >>> tr.v-data-table__selected {
    background: #bbdefb !important;
}

.no-shadow .v-card {
    box-shadow: none !important;
}

.bg-success {
    background-color: #00cf3f !important;
}

.bg-error {
    background-color: #ff9f9e !important;
}

.select-page {
    margin-top: -81px !important;
    right: 0;
    margin-left: 20px;
    padding-right: 100px;
}

.select-page .select-title {
    width: 70px;
}

.select-page .select-form {
    width: 120px;
}
</style>



// WEBPACK FOOTER //
// ItemBank.vue?55f5de10